import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export type ApproveSuggestedContentPreview = Api.IPagedCollection<Api.IContentCalendarSuggestion>;

export const getApproveSuggestedContentPreviewCount = (preview?: ApproveSuggestedContentPreview) =>
	preview?.totalCount ?? preview?.values?.length ?? 0;

type ApproveSuggestedContentPreviewVariables = {
	calendarId: string;
	impersonationContext?: Api.IImpersonationContext;
	suggestionIds?: string[];
	toolCall: Api.ContentCalendarResourceToolCall;
};

export const useApproveSuggestedContentPreviewMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: ApproveSuggestedContentPreview, variables: ApproveSuggestedContentPreviewVariables) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ calendarId, impersonationContext }: ApproveSuggestedContentPreviewVariables) => {
			return userSession.webServiceHelper.callAsync<ApproveSuggestedContentPreview>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `ContentCalendarSuggestion/calendar/${calendarId}/confirm/preview`,
					impersonationContext,
				}),
				'GET',
				null
			);
		},
		onError,
		onSuccess,
	});
};
